import { Visit } from '../types/visit';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';
import { useUser } from '../../../features/settings/hooks/useUser';

interface VisitInfoHeaderProps {
  visit: Visit;
}

export function VisitInfoHeader({ visit }: VisitInfoHeaderProps) {
  const { data: physician, isLoading: isLoadingPhysician } = useUser(visit.doctorId);

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="border-b">
        <CardTitle>Visit Information</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid grid-cols-3 gap-6">
          <div>
            <Label className="text-gray-500">Reason for Visit</Label>
            <p className="font-medium">{visit.reason}</p>
          </div>
          <div>
            <Label className="text-gray-500">Duration</Label>
            <p className="font-medium">{visit.duration} minutes</p>
          </div>
          <div>
            <Label className="text-gray-500">Physician</Label>
            {isLoadingPhysician ? (
              <p className="font-medium">Loading physician details...</p>
            ) : physician ? (
              <div>
                <p className="font-medium">
                  {physician.title} {physician.firstName} {physician.lastName}
                </p>
                {physician.specialization && (
                  <p className="text-sm text-muted-foreground">{physician.specialization}</p>
                )}
              </div>
            ) : (
              <p className="font-medium">Physician details not found</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
